module.exports = __webpack_public_path__ + "static/img/08.7f6be39d.png";